import { useTranslation } from 'react-i18next';
import { DateDropdownOptions } from '@/services/dictionaries/DateRangeValues';
import useMobile from '@/services/hooks/useMobile';
import {
    TIME_RANGE_WEEK,
    TIME_RANGE_TWO_WEEKS,
    TIME_RANGE_MONTH,
    TIME_RANGE_THREE_MONTHS,
    TIME_RANGE_SIX_MONTHS,
    TIME_RANGE_YEAR,
} from '@/services/constants';

export const useDateDropdownOptions = (): { label: string; value: number | string }[] => {
    const { t } = useTranslation();
    const isMobile = useMobile();
    const getOptionValue = (value: number): number | string => (isMobile ? value.toString() : value);
    const allOption = { label: t('all'), value: DateDropdownOptions.All };
    const calendarOption = { label: t('specifictimerange'), value: DateDropdownOptions.Calendar };
    const restOptions = [
        { label: t('last7days'), value: getOptionValue(TIME_RANGE_WEEK) },
        { label: t('last14days'), value: getOptionValue(TIME_RANGE_TWO_WEEKS) },
        { label: t('last30days'), value: getOptionValue(TIME_RANGE_MONTH) },
        { label: t('last3months'), value: getOptionValue(TIME_RANGE_THREE_MONTHS) },
        { label: t('last6months'), value: getOptionValue(TIME_RANGE_SIX_MONTHS) },
        { label: t('lastyear'), value: getOptionValue(TIME_RANGE_YEAR) },
    ];
    if (isMobile) {
        return [allOption, ...restOptions, calendarOption];
    }
    return [calendarOption, ...restOptions, allOption];
};
